import { ListItemIcon, ListItemText, MenuItem, Typography } from "@mui/material";
import { MessageSeverity } from "@sinch/core/entities/serverEnums";
import { MdsStar } from "@sinch/icons";
import { parseMutationErrorsFromData } from "@sinch/utils/apollo";
import { useSnackbar } from "notistack";
import { propEq } from "ramda";
import { isNotNilOrEmpty } from "ramda-adjunct";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { MdsIcon } from "@sinch/components";
import { useRatelist } from "@sinch/components/application/Rate/useRatelist";
import { ConfirmDialogWrapper } from "@sinch/components/ConfirmDialogWrapper/ConfirmDialogWrapper";

export const SetDefaultForCompanyMenuItem = ({
  id,
  companyId,
  onPerformedAction,
}: {
  id: string;
  companyId: string;
  onPerformedAction: () => void;
}) => {
  const { t } = useTranslation(["common", "draft"]);
  const { setDefaultForCompany } = useRatelist();
  const { enqueueSnackbar } = useSnackbar();

  const handleConfirm = useCallback(async () => {
    try {
      const response = await setDefaultForCompany({ variables: { ratelistId: id, companyId } });
      const firstMessage = parseMutationErrorsFromData(response).find((message) =>
        propEq("severity", MessageSeverity.Error)(message)
      )?.message;
      if (isNotNilOrEmpty(firstMessage)) {
        enqueueSnackbar(firstMessage, { variant: "error" });
      }
      onPerformedAction();
    } catch {
      enqueueSnackbar(t("ratelistError"), { variant: "error" });
    }
  }, [setDefaultForCompany, id, companyId, onPerformedAction, enqueueSnackbar, t]);

  return (
    <ConfirmDialogWrapper
      content={<Typography>{t("CompanyRatelist.confirmSetDefaultForCompany")}</Typography>}
      label={t("RateBuilder.confirmSetDefaultTitle")}
      onConfirm={handleConfirm}
      render={({ openConfirmation }) => (
        <MenuItem color="info" onClick={openConfirmation}>
          <ListItemIcon>
            <MdsIcon color="info" icon={MdsStar} />
          </ListItemIcon>
          <ListItemText sx={{ color: "info.main" }}>{t("CompanyRatelist.setDefaultForCompany")}</ListItemText>
        </MenuItem>
      )}
    />
  );
};
